import React, { type MouseEvent } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import type { AnalyticsEvent } from '@atlassian/jira-common-analytics-v2-wrapped-components/src/types';
import type { AppType } from '../../../common/constants';
import type { CommunicationWorkspaceConnection } from '../../../services/types';
import { SlackWorkspaceSettingsTitle } from './settings-title';
import { WorkspacesList } from './workspaces';

type Props = {
	hasWorkspacesConnected: boolean;
	workspaceConnections?: CommunicationWorkspaceConnection[];
	onConnectWorkspaceButtonClick?: (e: MouseEvent, analyticsEvent: AnalyticsEvent) => void;
	appType: AppType;
};

export const WorkspaceConnectionSettings = ({
	workspaceConnections,
	hasWorkspacesConnected,
	onConnectWorkspaceButtonClick,
	appType,
}: Props) => (
	<Box xcss={SettingContainerV2Style}>
		<SlackWorkspaceSettingsTitle
			appType={appType}
			onConnectWorkspaceButtonClick={onConnectWorkspaceButtonClick}
		/>
		{hasWorkspacesConnected && workspaceConnections !== undefined && (
			<WorkspacesList workspaceConnections={workspaceConnections} appType={appType} />
		)}
	</Box>
);

const SettingContainerV2Style = xcss({
	paddingTop: 'space.150',
	paddingRight: 'space.600',
	paddingBottom: 'space.100',
	paddingLeft: 'space.600',
});
